import type { NuxtError } from '#app'
import type { AsyncData, AsyncDataOptions, PickFrom, KeysOf, AsyncDataHandler } from '#app/composables/asyncData'
import { reportError } from '~/utils/error'

export const useAsyncDataWithCapture = <
  ResT,
  NuxtErrorDataT = unknown,
  DataT = ResT,
  PickKeys extends KeysOf<DataT> = KeysOf<DataT>,
  DefaultT = null
>(
  handler: AsyncDataHandler<ResT>,
  options?: AsyncDataOptions<ResT, DataT, PickKeys, DefaultT>
): AsyncData<
  PickFrom<DataT, PickKeys> | DefaultT,
  (NuxtErrorDataT extends Error | NuxtError ? NuxtErrorDataT : NuxtError<NuxtErrorDataT>) | undefined
> => {
  const cacheKey = crypto.randomUUID()
  return useAsyncData(cacheKey, captureWrapper(handler), options)
}

const captureWrapper: <T>(handler: AsyncDataHandler<T>) => AsyncDataHandler<T> = (handler) => {
  return async (ctx, opt) => {
    try {
      return await handler(ctx, opt)
    } catch (e) {
      reportError(e)
      throw e
    }
  }
}
